export const SUPPLIER_DTO_STATUS = {
  BLOCKED: 'B',
  ACTIVE: '',
} as const;
